// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx","848":"6b527e28d2d333693b2436b1f42a8182b35267a1","914":"component---src-pages-skillset-tsx"}[chunkId] + "-" + {"245":"0404acdea34ed3bab3a1","453":"517595c0d7be473274a3","848":"3ee76a101eb9dc61e5a0","914":"5aaddaefa81af9a74df7"}[chunkId] + ".js";
};